import { createSelector } from '@ngrx/store';
import { getMultipleOrderModalState } from '../reducers';

export const selectProductTypeState = createSelector(getMultipleOrderModalState, state => state && state.productType);

export const selectProductTypes = createSelector(selectProductTypeState, (state) => state && state.payload);

export const selectActiveProductTypeId = createSelector(selectProductTypes, (state) => state && state.activeEntityId);

export const selectActiveProductTypeEntity = createSelector(
  selectActiveProductTypeId,
  selectProductTypes,
  (id, state) => state && state.entities[id],
);

export const selectAllProductTypeIds = createSelector(selectProductTypes, (state) => state && state.ids);

export const selectAllProductTypes = createSelector(
  selectAllProductTypeIds,
  selectProductTypes,
  (ids, state) => {
    // @TODO Its showing some kind of weird error, Im not able to to solve this right now
    const _ids: any[] = ids;
    const _entities = state.entities;
    const aux = _ids.map(id => _entities[id]);
    aux.sort((a, b) => {
      if (a.productTypeId > b.productTypeId) {
        return -1;
      }
      if (a.productTypeId < b.productTypeId) {
        return 1;
      }
      return 0;
    });
    return aux;
  },
);

export const selectProductTypesStatus = createSelector(
  selectProductTypeState,
  ({ isFetched, isLoading, hasError }) => ({
    isFetched,
    isLoading,
    hasError,
  }),
);

